import { computed, shallowRef, watch } from 'vue'
import { defineStore } from 'pinia'
import { useAuthStore } from './auth'

export interface CaptureConnectivityContext {
  clubId: string; seasonId: string; eventId: string; sessionId: string
  ready: boolean; locked: boolean; expired: boolean; preparing: boolean; saving: boolean
  pending: number; attention: number; syncing: boolean; restartReady: boolean; error: boolean
  canPrepare: boolean
  prepare(): void; review(): void; inventory(): void
}
/** Transient UI state only; snapshots and commands remain in the existing outbox. */
export const useCaptureConnectivity = defineStore('capture-connectivity', () => {
  const active = shallowRef<CaptureConnectivityContext | null>(null)
  const failures = shallowRef<Record<string,string>>({})
  const failed = computed(() => Object.keys(failures.value).length > 0)
  let owner: symbol | null = null
  function publish(source: symbol, context: CaptureConnectivityContext) { owner=source; active.value=context }
  function release(source: symbol) { if(owner===source) {owner=null;active.value=null} }
  function saveOutcome(key: string, path: string, saved: boolean) {
    const next={...failures.value}
    if(saved) delete next[key]; else next[key]=path
    failures.value=next
  }
  const auth=useAuthStore()
  watch(()=>[auth.user?.id,auth.isMasquerading],()=>{owner=null;active.value=null;failures.value={}}, {flush:'sync'})
  return {active,failures,failed,publish,release,saveOutcome}
})
